import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Button, Spinner, Modal, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import swal from "sweetalert2";
import Preloader from "../Preloader";
import { sendQuotation } from "../../redux/actions/EnquiryActions";

const EnquiryNoteWithFileUpload = ({ show, onHide, enquiryid }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const {
        AuthReducer: { auth, errors },
        enquiryReducer: { loadingEnquiry, errorsEnquiry, changedEnquiryStatus }
    } = useSelector((state) => state);

    const [formData, setFormData] = useState({
        title: "",
        disposition: "",
        note: "",
        file: null
    });
    useEffect(() => {
        if (!show) {
            setFormData({ title: "", disposition: "", note: "", file: null });
        }
    }, [show]);
    const handleChange = (e) => {
        const { name, value, files } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: files ? files[0] : value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const formDataToSend = new FormData();

        Object.entries(formData).forEach(([key, value]) => {
            if (value) formDataToSend.append(key, value);
        });
        formDataToSend.append("enquiry_id", enquiryid);

        dispatch(sendQuotation(auth?.token, formDataToSend));
    };

    useEffect(() => {
        if (errors?.status === 401) {
            dispatch(logout());
            toast.error(errors?.data?.message);
            onHide();
        }
    
        if (changedEnquiryStatus?.status || changedEnquiryStatus?.success) {
            swal.fire({
                title: "Well done!",
                text: changedEnquiryStatus?.message,
                icon: "success",
                timer: 1500,
                showConfirmButton: false
            });
            setFormData({ title: "", disposition: "", note: "", file: null });
            dispatch({ type: "RESET_DELETE_ENQUIRY_STATUS" });
            onHide();
        }
    }, [errors, changedEnquiryStatus, dispatch, onHide]);

    return (
        <Modal show={show} onHide={onHide} size="lg" backdrop="static" className="scrollable-modal">
            <Modal.Header closeButton>
                <Modal.Title>{t("Send Quotation")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {errorsEnquiry?.data?.message && (
                    <div className="alert alert-danger">
                        {errorsEnquiry.data.message}
                    </div>
                )}

                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col lg={12}>
                            <Form.Group controlId="formFile" className="mb-3">
                                <Form.Label>{t("Upload Quotation File")}</Form.Label>
                                <Form.Control
                                    type="file"
                                    name="file"
                                    onChange={handleChange}
                                    accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx"
                                />
                                {errorsEnquiry?.data?.file && (
                                    <div className="invalid-feedback d-block text-danger">
                                        {errorsEnquiry.data.file}
                                    </div>
                                )}
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <Form.Group controlId="formFile" className="mb-3" >
                                <div className="d-flex align-items-center gap-3">
                                    <Form.Check
                                        type="checkbox"
                                        label="Send Email"
                                        id="checkbox1"
                                        checked={true}
                                    />
                                    <Form.Check
                                        type="checkbox"
                                        label="Send Whatapp"
                                        id="checkbox2"
                                    />
                                </div>
                            </Form.Group>
                        </Col>
                    </Row>


                    <div className="d-flex justify-content-center">
                        <Button type="submit" disabled={loadingEnquiry}>
                            {loadingEnquiry ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    {t("Please wait ...")}
                                </>
                            ) : (
                                t("Send")
                            )}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
            {loadingEnquiry && <Preloader />}
        </Modal>
    );
};

export default EnquiryNoteWithFileUpload;
